export default __webpack_public_path__ + "img/5ef22980313564dbedfbbf3974ba2684.png";